<template>
  <div class="card">
    <div class="card-content">
      <h1 class="title is-spaced">Copy to HubSpot</h1>
      <div class="content">
        <ul>
          <li>Open "Profile & Preferences"</li>
          <li>Under "CRM Communication" click "Edit Signature"</li>
          <li>Toggle the "HTML" tab and paste the content below</li>
          <li>Click "Save"</li>
        </ul>
        <textarea
          class="hubspot-result textarea has-fixed-size"
          v-model="htmlContent.outerHTML"
          rows="10"
        ></textarea>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['htmlContent'],
  name: 'HubSpotModal'
}
</script>